// extracted by mini-css-extract-plugin
export default {"slide":"slide_slide__JAfxg","slideSTC":"slide_slideSTC__vov5f","slideHeader":"slide_slideHeader__5B7ri","slideText":"slide_slideText__2d3vi"};